import { LogOutIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { toast } from 'sonner';

import { useTenantName } from '@/components/providers/config-provider';
import { useToasterId } from '@/components/toaster-context';
import { Button } from '@/components/ui/button';
import { signOut } from '@/lib/guest-auth/browser-client';
import { useHistorySession } from '@/lib/history-key/session';
import { isWebsiteBrowser } from '@/lib/website-auth/browser';

/** Inside a tenant site the host's own logout ends its session, so the button is only for the
 *  in-chat sign-in that stands in for it there. */
export function SignOutButton() {
  const t = useTranslations();
  const tenantName = useTenantName();
  const toasterId = useToasterId();
  const signedIn = useHistorySession(state => state.signedIn);
  const inChat = useHistorySession(state => state.inChat);
  if (!signedIn || (isWebsiteBrowser(tenantName) && !inChat)) return null;

  // Signed out here already: only the server's confirmation is late, and it is retried on its own.
  function handleClick() {
    return signOut(tenantName).catch(function notePendingSignOut() {
      toast.info(t('threadList.signOutPending'), { toasterId });
    });
  }

  return (
    <Button
      onClick={handleClick}
      className="aui-sign-out h-7 gap-1.5 px-2 text-xs font-medium text-muted-foreground hover:text-accent-foreground"
      variant="ghost"
    >
      <LogOutIcon className="size-4" />
      {t('threadList.signOutButton')}
    </Button>
  );
}
